function unwrapAttributes(entity) {
  if (!entity) return null;
  if (entity.attributes) {
    return { id: entity.id, ...entity.attributes };
  }
  return entity;
}

function normalizePosgradoMateria(entry) {
  if (!entry) return null;
  const flat = unwrapAttributes(entry);
  return {
    id: flat.id ?? entry.id,
    Titulo: flat.Titulo ?? "",
    Clave: flat.Clave ?? "",
    HBCA: Number(flat.HBCA) || 0,
    HTI: Number(flat.HTI) || 0,
    Creditos: Number(flat.Creditos) || 0,
    Semestre: Number(flat.Semestre) || 0,
    Eje: flat.Eje ?? flat.Trayecto ?? "",
    Trayecto: flat.Eje ?? flat.Trayecto ?? "",
    Orden: Number(flat.Orden) || 1,
    SpanTrayectos: 1,
  };
}

function normalizeMateriasList(mallaBlock) {
  if (!mallaBlock) return [];
  const raw =
    mallaBlock.Materias?.data ??
    mallaBlock.Materias ??
    [];
  const list = Array.isArray(raw) ? raw : [];
  return list.map(normalizePosgradoMateria).filter(Boolean);
}

function normalizeMallaCurricular(mallaRelation) {
  const malla = unwrapAttributes(mallaRelation?.data ?? mallaRelation);
  if (!malla) {
    return {
      Vigencia: "",
      Titulo: "Malla curricular",
      Materias: [],
    };
  }
  return {
    Vigencia: malla.Vigencia ?? "",
    Titulo: malla.Titulo ?? "Malla curricular",
    Modalidad: malla.Modalidad ?? "",
    SemanasPorSemestre: malla.SemanasPorSemestre ?? null,
    TotalHBCA: malla.TotalHBCA ?? null,
    TotalHTI: malla.TotalHTI ?? null,
    TotalHoras: malla.TotalHoras ?? null,
    TotalCreditos: malla.TotalCreditos ?? null,
    TotalAsignaturas: malla.TotalAsignaturas ?? null,
    Materias: normalizeMateriasList(malla),
  };
}

export function normalizePosgradoResponse(strapiPayload) {
  const root = strapiPayload?.data ?? strapiPayload;
  const flat = unwrapAttributes(root);
  if (!flat) {
    return { id: null, attributes: null };
  }

  const mallaRaw = flat.MallaCurricular?.data ?? flat.MallaCurricular;

  return {
    id: flat.id ?? root?.id ?? null,
    attributes: {
      Nombre: flat.Nombre ?? "",
      Descripcion: flat.Descripcion ?? "",
      Informacion: flat.Informacion ?? null,
      MallaCurricular: normalizeMallaCurricular(mallaRaw ?? flat.MallaCurricular),
    },
  };
}
